<template>
  <div>
    <div class="text-center" v-if="!dataLoaded">
      <v-progress-circular class="mt-6" :size="50" color="primary" indeterminate />
    </div>

    <div class="mt-4" v-else>
      <v-row class="my-0">
        <v-col cols="12" class="pt-0">
          <v-row>
            <v-col cols="12" md="7" class="d-flex">
              <v-btn
                outlined small rounded
                color="primary"
                class="white--text px-4"
                @click="dialog = true"
              >
                <v-icon left small>mdi-plus</v-icon>Добавить
              </v-btn>
            </v-col>
          </v-row>

          <PageTable
            :table-loading="tableLoading"
            :table-headers="tableHeaders"
            :table-items="orders.list"
            filter
          >
            <template v-slot:item.actions="{ item }">
              <v-icon color="lightGrey" class="mr-1 edit-btn" size="22" title="Загрузка приказа" @click="downloadReport(item, $event)">
                mdi-download
              </v-icon>
              <v-icon color="lightGrey" class="mr-1 edit-btn" size="22" title="Рейтинговые баллы" @click="addOrderLine(item)">
                mdi-file-document-edit-outline
              </v-icon>
              <v-icon color="lightGrey" class="mr-1 edit-btn" size="22" title="Редактировать" @click="edit(item)">
                mdi-pencil-outline
              </v-icon>
              <v-icon color="lightGrey" class="remove-btn" size="22" title="Удалить" @click="remove(item)">
                mdi-trash-can-outline
              </v-icon>
            </template>
          </PageTable>
        </v-col>
      </v-row>
    </div>

    <ConfirmDialog
      :dialog="confirmDialog"
      :loading="btnLoading"
      :message="`Вы уверены, что хотите удалить значение из справочника?`"
      @confirm="removeOrder"
      @closeModal="closeDialog"
    />

    <OrderDialog
      :dialog="dialog"
      :loading="btnLoading"
      :selectedItem="selectedItem"
      @saveOrder="saveOrder"
      @closeModal="closeDialog"
    />
  </div>
</template>

<script>
import {curatorApi, orderApi, orderLineApi, protocolApi, reportControllerApi} from '@/api'
import { mapGetters } from 'vuex'
import { OrderParent, OrderLine } from '@/models'
import OrderDialog from '@/components/zvp/documentationSetup/dialogs/Order'
import PageTable from '@/components/ui/Table'
import ConfirmDialog from '@/components/dialogs/ConfirmDelete'
import download from '@/plugins/download'

export default {
  name: 'Orders',

  components: {
    OrderDialog,
    ConfirmDialog,
    PageTable
  },

  async created() {
    await this.$store.dispatch('user/getCurrent')
    await this.getOrderList()
    this.dataLoaded = true
  },

  data: () => ({
    tableHeaders: [
      { text: 'Номер приказа', value: 'orderNumber', sortable: false, align: 'start' },
      { text: 'Дата приказа', value: 'orderDateText', sortable: false, align: 'start'},
      { text: 'Дата начала действия', value: 'effectiveDateText', sortable: false, align: 'start'},
      // { text: 'Вид оплаты', value: 'paidForm.name', sortable: false, align: 'start'},
      { text: 'Специальность', value: 'speciality.name', sortable: false, align: 'start'},
      { text: 'Факультет', value: 'department.name', sortable: false, align: 'start'},
      { text: 'Действия', value: 'actions', sortable: false, align: 'center', width: '160px' },
    ],
    orders: new OrderParent(),
    applicationParamDto: new OrderLine(),
    tableLoading: false,
    selectedItem: null,
    confirmDialog: false,
    isShowMode: false,
    btnLoading: false,
    dataLoaded: false,
    dialog: false,
    rangingDialog: false,

    pageNumber: 0,
    lastPage: false,
  }),

  computed: {
    ...mapGetters('user', ['isCurator', 'isAdmin']),

    checkRoles() {
      return this.isCurator || this.isAdmin
    },
  },

  methods: {
    async getOrderList() {
      try {
        this.tableLoading = true
        if (!this.lastPage && this.checkRoles) {
          const data = await orderApi.getCatalog()
          if (data.length) data.forEach(obj => this.orders.addOrder(obj))
        }
      } catch (e) {
        this.showErrorMessage(e, 'Возникла ошибка')
      } finally {
        this.tableLoading = false
      }
    },

    addOrderLine(item) {
      this.$router.push(`/zvp/documentation-setup/order-line/${item.id}`)
    },

    async downloadReport(item, event) {
      event.target.classList.add('mdi-loading')
      try {
     //   const data = await reportControllerApi.getOrderReport(item.id)
     //   data && download(data, 'Order.pdf')
      }
      catch (e) {
        this.showErrorMessage(e, 'Ошибка загрузки')
      }
      finally {
        event.target.classList.remove('mdi-loading')
      }
    },

    edit(item) {
      this.selectedItem = item
      this.dialog = true
    },

    remove(item) {
      this.selectedItem = item
      this.confirmDialog = true
    },

    async saveOrder(body) {
      try {
        this.btnLoading = true
        // let data
        // if (body.id) {
        //   data = await orderApi.updateOrder(body.id, body)
        // } else {
        //   data = await orderApi.saveOrder(body)
        //   const filterApplications = await curatorApi.filterApplications(this.applicationParamDto.curatorFilter())
        //   const bodyForOrder = filterApplications.map(item => item.id)
        //   await orderLineApi.createOrderLine(data.id, bodyForOrder)
        // }

        const data = body.id ? await orderApi.update(body) : await orderApi.create(body)
        body.id ? this.orders.updateOrder(data) : this.orders.addOrder(data)

        this.$toastr('success', '', 'Успешно сохранено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка сохранения')
      } finally {
        this.btnLoading = false
      }
    },

    async removeOrder() {
      try {
        this.btnLoading = true
        // this.selectedItem.orderLines.map(async item => await curatorApi.passApplication(item.application.id))
        // await orderApi.removeOrder(this.selectedItem.id)
        // this.orders.removeOrder(this.selectedItem.id)
        this.$toastr('success', '', 'Успешно удалено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка удаления')
      } finally {
        this.btnLoading = false
      }
    },

    closeDialog() {
      this.dialog = false
      this.confirmDialog = false
      this.selectedItem = null
    },
  },
}
</script>

<style scoped>
.mdi-loading {
  animation: spinner 1s linear infinite;
}

@keyframes spinner {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
